(function ($) {
	$.fn.lmDropdowns = function(options) {
		// NOTE: Don't run logic below if nothing is in the dom
		if (!this.length) {
			return false;
		}
		
		// Default settings are set here
		var settings = $.extend({
			selector: '.dropdown',
			navSelector: '.main-menu__item',
			boxClass: 'dropdown--box'
		}, options);
		
		// These are all the methods available for the plugin
		var methods = {},
		$dropdown,
		$navigation,
		buttonSelector,
		linkSelector;

		methods.toggleDropdown = function($context) {
			if ($context.hasClass('dropdown--open')) {
				// Close dropdown
				$context.addClass('dropdown--closed').removeClass('dropdown--open');
			} else {
				// Close all other dropdowns and open current dropdown
				$dropdown.removeClass('dropdown--open');
				
				$('.show-menu').addClass('hide-menu').removeClass('show-menu');
				$('.has-share-drop--show').addClass('has-share-drop--hide').removeClass('has-share-drop--show');

				$context.removeClass('dropdown--closed').addClass('dropdown--open');
			}
		}

		methods.setCurrentSettings = function($context) {
			// Set settings
			var currentSettings = $context.data();
			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}
			// Initialize item
			$context.data('initialized', true);

			// Init individual button
			var $button = $context.find(buttonSelector);
			var $dropdownLinks = $context.find(linkSelector);

			$button.off('click.lmDropdowns').on('click.lmDropdowns', function(event) {
				event.preventDefault();
				event.stopPropagation();
				var $currentContextParent = $(event.currentTarget).parent();
				methods.toggleDropdown($currentContextParent);
			});

			$dropdownLinks.off('click.lmDropdowns').on('click.lmDropdowns', function(event) {
				var $this = $(this);
				var this_text = $this.html() + '<svg class="icon"><use xmlns:xlink="https://www.w3.org/1999/xlink" xlink:href="/themes/custom/nhra/assets/images/sprite.svg#arrow-down"></use></svg>';
				//$button.find(settings.selector + '__text-wrap').html(this_text);
				$context.removeClass('dropdown--open');
			});

			$(document).off('click.lmDropdowns').on('click.lmDropdowns', function(event) {
				$('.dropdown--open').removeClass('dropdown--closed').removeClass('dropdown--open');
			});

			if($context.hasClass(settings.boxClass)) {
				var $dropdownList = $context.find('.dropdown__list');
				$context.find('.dropdown__text-wrap').css({'min-width' : $dropdownList.width() + 'px'});
				$dropdownList.css({width: '100%'});
			}
		}

		methods.initContext = function($context) {
			$dropdown = $(settings.selector);
			$navigation = $(settings.navSelector);
			buttonSelector = settings.selector + '__button';
			linkSelector = settings.selector + '__link';
			methods.setCurrentSettings($context);
		}
		
		// Filter each function
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);
			// NOTE: Method you'd like initialized on a per context basis
			methods.initContext($this);
		});
};

}(jQuery));
